<template>
  <div>
    <v-container>
      Conselho inativo
    </v-container>
  </div>
</template>

<script>

export default {
  name: "Inativo",
  inject: ["theme"],
  data: () => ({
  }),
  created() {
  },
  methods: {}
};
</script>